const STAMPED_WIDGET_URL = 'https://cdn1.stamped.io/files/widget.min.js';

export default defineNuxtPlugin((nuxtApp) => {
  let scriptPromise: Promise<void> | undefined;

  const loadStampedWidget = () => {
    if (scriptPromise) return;

    scriptPromise = new Promise((resolve, reject) => {
      const existingScript = document.querySelector<HTMLScriptElement>(`script[src="${STAMPED_WIDGET_URL}"]`);
      if (existingScript) {
        if (existingScript.dataset.loaded === 'true') resolve();
        else existingScript.addEventListener('load', () => resolve(), { once: true });
        return;
      }

      const script = document.createElement('script');
      script.src = STAMPED_WIDGET_URL;
      script.async = true;
      script.addEventListener('load', () => {
        script.dataset.loaded = 'true';
        window.dispatchEvent(new Event('stamped:script-loaded'));
        resolve();
      }, { once: true });
      script.addEventListener('error', () => reject(new Error('Unable to load Stamped widget')), { once: true });
      document.head.appendChild(script);
    }).catch((error) => {
      scriptPromise = undefined;
      console.error(error);
    });
  };

  const loadAfterInteraction = () => {
    loadStampedWidget();
  };

  nuxtApp.hook('app:mounted', () => {
    // Stamped provides the star-icon font used by product cards across the site.
    // Load it after the first real interaction so it remains available on listings
    // without competing with the initial mobile render/LCP.
    window.addEventListener('scroll', loadAfterInteraction, { once: true, passive: true });
    window.addEventListener('touchstart', loadAfterInteraction, { once: true, passive: true });
    window.addEventListener('mousemove', loadAfterInteraction, { once: true, passive: true });
    window.addEventListener('keydown', loadAfterInteraction, { once: true });
  });
});
